import { render } from "./ViewOrders.vue?vue&type=template&id=a971619c&scoped=true"
import script from "./ViewOrders.vue?vue&type=script&lang=js"
export * from "./ViewOrders.vue?vue&type=script&lang=js"

import "./ViewOrders.vue?vue&type=style&index=0&id=a971619c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a971619c"]])

export default __exports__